import React from 'react'
import { connect } from 'react-redux'

import { handleError } from '../actions'
import { setMaintenanceInfo } from '../actions/admin'

import '../styles/maintenance-info-edit.scss'

class MaintenanceInfoEdit extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            maintenanceInfo: props.maintenanceInfo && props.maintenanceInfo.text || ''
        }
    }
    onSave(e) {
        e.preventDefault()
        this.props.setMaintenanceInfo(this.state.maintenanceInfo).catch(err => this.props.handleError(`Error setting maintenance info (${err})`))
    }
    onRemove(e) {
        e.preventDefault()
        this.props.setMaintenanceInfo(null)
        this.setState({ maintenanceInfo: '' })
    }
    render() {
        return (
            <form className="maintenance-info-edit">
                <div>
                    <textarea value={this.state.maintenanceInfo} onChange={e => this.setState({ maintenanceInfo: e.target.value })} />
                </div>
                <div className="buttons">
                    {this.props.maintenanceInfo && <button className="btn" onClick={this.onRemove.bind(this)}>remove</button>}
                    <button className="btn" onClick={this.onSave.bind(this)}>save</button>
                </div>
            </form>
        )
    }
}

export default connect(state => ({
    maintenanceInfo: state.config.maintenanceInfo
}), { setMaintenanceInfo, handleError })(MaintenanceInfoEdit)


// WEBPACK FOOTER //
// ./containers/MaintenanceInfoEdit.jsx